// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2IQ4A","footer":"ModalCreateQualiphyProcedure_footer__1ge1-","additionData":"ModalCreateQualiphyProcedure_additionData__2YZkr"};